<template>
  <div id="app" style="background-color: rgba(235, 235, 235, 0.08)">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  props: {
    transition: {
      type: String,
      default: () => 'el-fade-in'
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  overflow: hidden;
}
*{
  padding:0;
  margin:0;
}
::-webkit-scrollbar-track
{
  background: rgba(0,0,0,.1);
  border-radius: 0;
}

::-webkit-scrollbar
{
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb
{
  cursor: pointer;
    border-radius: 5px;
  background: rgba(0,0,0,.25);
  transition: color .2s ease;
}
</style>



// WEBPACK FOOTER //
// src/App.vue